import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

export default function SkillDemo({ skill, onClose }) {
  const { t } = useTranslation();
  if (!skill) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="relative w-full max-w-2xl bg-zinc-950 border border-zinc-800 p-8 max-h-[80vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-zinc-500 hover:text-white transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-3">
          {skill.category}
        </div>
        <h2 className="font-display text-3xl uppercase mb-4">{skill.name}</h2>
        <p className="text-zinc-400 leading-relaxed mb-6">{skill.description}</p>

        {skill.steps && (
          <div className="mb-6">
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-amber-500 mb-3">
              {t('skills_page.how_it_works')}
            </h3>
            <ol className="space-y-2">
              {skill.steps.split('\n').map((step, i) => (
                <li key={i} className="flex gap-3 text-sm text-zinc-300">
                  <span className="font-mono text-[10px] text-amber-500 shrink-0 mt-0.5">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        )}

        {skill.tags && skill.tags.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-6">
            {skill.tags.map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 border border-zinc-800 text-[9px] font-mono uppercase tracking-wider text-zinc-500"
              >
                {tag}
              </span>
            ))}
          </div>
        )}

        <button
          onClick={onClose}
          className="w-full bg-amber-500 hover:bg-amber-400 text-black px-6 py-3 font-mono text-xs uppercase tracking-wider transition-colors"
        >
          {t('common.close')}
        </button>
      </div>
    </div>
  );
}
